module.exports = __webpack_public_path__ + "img/banner.2e3b561f.png";